import PropTypes from 'prop-types';

import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import CopyComponent from 'components/field/CopyComponent';
import FormItem from 'components/form/FormItem';

import { usePrompt } from 'hooks/usePrompt';

import * as S from '../SalesChannel.styled';
import BaseSalesChannelForm from './BaseSalesChannelForm';

const StoreBasicConfigForm = ({ children }) => {
	const { t } = useTranslation();
	const formMethods = useFormContext();

	const {
		watch,
		formState: { isSubmitting, isDirty, isSubmitSuccessful, isLoading: isFormLoading }
	} = formMethods;

	const isLoading = isSubmitting || isFormLoading;

	usePrompt(isDirty && !isSubmitting && !isSubmitSuccessful);

	return (
		<S.StoreAccordion header="storeDetails" defaultVisible>
			<BaseSalesChannelForm isLoading={isLoading}>
				{children}
				<FormItem label="refreshToken" isLoading={isLoading}>
					<CopyComponent
						value={watch('token') || t('saveTheFormToGetToken')}
						buttonDisabled={!watch('token')}
					/>
				</FormItem>
			</BaseSalesChannelForm>
		</S.StoreAccordion>
	);
};

StoreBasicConfigForm.propTypes = {
	children: PropTypes.node
};

StoreBasicConfigForm.defaultProps = {
	children: null
};

export default StoreBasicConfigForm;
